import makeRequest from '../../utils/makeRequest';
import { getSiteDomain } from '../../utils/common';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import { getWeatherUrl } from './config';
import utils from './WeatherUtil';

const reducerName = 'weather';

const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');

function weatherData(data, id) {
  return {
    type: RECEIVE_DATA,
    payload: {
      weatherData: data,
      cityPostalId: id,
    },
  };
}

export function fetchWeatherData(params, isPrimeUser) {
  const PRIME_FORCAST_LOCATION_URL = `${getSiteDomain()}/toiignorevp/forecast_location_country_ext.cms`;
  const NON_PRIME_FORCAST_LOCATION_URL = `${getSiteDomain()}/forecast_location_country_ext.cms`;
  const FORCAST_LOCATION_URL = isPrimeUser
    ? PRIME_FORCAST_LOCATION_URL
    : NON_PRIME_FORCAST_LOCATION_URL;

  let weatherUrls = [];
  if (params && params.latitude && params.longitude) {
    weatherUrls = [
      makeRequest.get(
        `${getWeatherUrl(isPrimeUser)}?lat=${params.latitude}&lng=${
          params.longitude
        }&unit=m`,
      ),
      makeRequest.get(
        `${FORCAST_LOCATION_URL}?countryCode=${params.countryCode}&query=${
          params.city
        }`,
      ),
    ];
  } else {
    weatherUrls = [
      makeRequest.get(
        `${FORCAST_LOCATION_URL}?countryCode=${params.countryCode}&query=${
          params.city
        }`,
      ),
    ];
  }
  return Promise.all(weatherUrls);
}

export function getWeatherData(params, isPrimeUser = false) {
  return dispatch =>
    fetchWeatherData(params, isPrimeUser)
      .then(data => {
        const [weatherForecastData, weatherLocationData] = data;
        dispatch(
          weatherData(
            utils.filterData(weatherForecastData.data),
            utils.filterLocation(weatherLocationData.data),
          ),
        );
      })
      .catch(error => {
        console.log(
          'Something went wrong while fetching weather data. Error details: ',
          error,
        );
      });
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA:
      return {
        ...state,
        weatherData: action.payload.weatherData,
        cityPostalId: action.payload.cityPostalId,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
